import { GetApp } from "@mui/icons-material"
import { Button } from "@mui/material"
import { LoadingButton } from "components/Button"
import ErrorDialog from "components/ErrorDialog"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { ExportExcelProps2, TableLoadingStateEnum } from "../tableProps.interface"
import useTableExport from "../useTableExport2"

const ExportToExcel: FC<ExportExcelProps2> = ({ columns, rows }) => {
  const [exportTableState, exportTable] = useTableExport()
  const { t } = useTranslation()

  return (
    <>
      {exportTableState === TableLoadingStateEnum.Error && (
        <ErrorDialog
          title={t("global.export_failed", "The export failed")}
          message={t("global.export_failed_message", "The export failed, reduce the size of the data using the filters and try again.")}
        />
      )}
      {exportTableState === TableLoadingStateEnum.Loading ? (
        <LoadingButton />
      ) : (
        <Button
          color="primary"
          startIcon={<GetApp />}
          onClick={() => {
            exportTable(columns, rows)
          }}>
          <span>{t("global.table.export", "Export")}</span>
        </Button>
      )}
    </>
  )
}

export default ExportToExcel
